import { useNavigate } from '@tanstack/react-router';
import type React from 'react';
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import rootStore from '~/store';

type Props = {
  children?: React.ReactNode;
};

export default function SuperAdminLayout({ children }: Props) {
  const navigate = useNavigate();
  const { me } = useSnapshot(rootStore);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (!me?.isSuperAdmin) {
      navigate({ to: '/admin' });
    }
  }, [me]);

  // Don't mount children for non-superadmins — otherwise the wrapped pages fire their
  // initial (forbidden) data requests before the redirect effect runs.
  if (!me?.isSuperAdmin) {
    return null;
  }

  return <>{children}</>;
}
